const COLORS = ['#f43f5e', '#fb7185', '#fda4af', '#ff6b9d', '#c026d3', '#e879f9'];
const COLORS_SOFT = ['#f43f5e', '#fb7185', '#fda4af'];

let confettiPromise = null;
// canvas-confetti is only fetched the first time a burst is actually shown.
const loadConfetti = () =>
  (confettiPromise ??= import('canvas-confetti').then((m) => m.default));

/**
 * Bursts a small confetti effect centered on the given element.
 * @param {HTMLElement} [target] - element to center the burst on (falls back to viewport center)
 */
export function burstFavoriteConfetti(target) {
  let origin = { x: 0.5, y: 0.5 };
  if (target) {
    const rect = target.getBoundingClientRect();
    origin = {
      x: (rect.left + rect.width / 2) / window.innerWidth,
      y: (rect.top + rect.height / 2) / window.innerHeight,
    };
  }

  loadConfetti().then((confetti) => {
    confetti({
      particleCount: 18,
      spread: 30,
      startVelocity: 12,
      decay: 0.85,
      scalar: 0.7,
      ticks: 60,
      shapes: ['circle'],
      colors: COLORS,
      origin,
      drift: 1.5,
      gravity: 0.4,
    });
    confetti({
      particleCount: 10,
      spread: 20,
      startVelocity: 8,
      decay: 0.88,
      scalar: 0.5,
      ticks: 60,
      shapes: ['circle'],
      colors: COLORS_SOFT,
      origin,
      drift: -1.5,
      gravity: 0.3,
    });
  });
}